import{createSignalRContext as t}from"./createSignalRContext.js";var{SignalRProvider:a,useSignalRContext:e}=t();export{a as SignalRProvider,e as useNotificationsSignalRContext};
//# sourceMappingURL=notificationsSignalRContext.js.map